// extracted by mini-css-extract-plugin
export var avatar = "_nw-3";
export var avatarContainer = "_nw-2";
export var avatarSpacer = "_nw-5";
export var avatarSpacerContainer = "_nw-4";
export var avatarStackContainer = "_nw-1";
export var bubble = "_nw-0";
export var remainderBubble = "_nw-6";